var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page__content checkout"},[_c('div',{staticClass:"shine"}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"cell large-8 large-offset-2 module__checkout"},[_c(_setup.AppHeader),_vm._v(" "),_c(_setup.BundleLoader)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }